module.exports = __webpack_public_path__ + "img/20250824.69a7d8a7.jpg";